import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

// layouts
import { MainLayout } from "layouts";

// components
import { MenuSections } from "components/all";
import { Loading } from "components/common";
import Text from "components/ui/Text";

import { ReactComponent as SuccessIcon } from "assets/icons/check-icon.svg";
import { ReactComponent as FailureIcon } from "assets/icons/danger-icon.svg";

// utils
import { api } from "utils";

const menuSections = [
  { label: "센터 이미지 설정", to: "/all/settings/center/image" },
  { label: "센터 정보 설정", to: "/all/settings/center/info" },
  { label: "대표자 정보 설정", to: "/all/settings/center/ceo" }
];



const CenterSettings = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [info, setInfo] = useState({});
  const [doorMessage, setDoorMessage] = useState("");
  const [doorError, setDoorError] = useState(false);
  const { partner, partnerBranch, seqPartner, seqPartnerBranch } =
    location.state;
  const [kiosks, setKiosks] = useState([]);

  const getKioskList = async () => {
    try {
      const { data } = await api.get(`/kiosk/list`, {
        params: { seqPartner, seqPartnerBranch: seqPartnerBranch || 0 },
      });
      setKiosks(data || []); // 리스트 저장
    } catch (error) {
      console.error("키오스크 리스트 불러오기 실패:", error);
      setKiosks([]); // 실패 시 빈 배열
    }
  };

  // ✅ 여기 handleOpenDoor 선언
  const handleOpenDoor = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/kiosk/open`, {
        params: { seqPartner,
                  seqPartnerBranch: seqPartnerBranch || 0,
                  kioskName: kiosks[0].kioskName
        }
      });

      if (data.code === "success") {
        const now = new Date();
        const timeString = now.toLocaleTimeString("ko-KR", {
          hour: "2-digit",
          minute: "2-digit",
        });
        setDoorMessage(
            <DoorMessage type="success">
              <SuccessIcon width={16} height={16} fill="#004FEC" />
              출입문이 열렸습니다 (시간: {timeString})
            </DoorMessage>
        );
        setDoorError(false);
      } else {
        setDoorMessage(
            <DoorMessage type="error">
              <FailureIcon width={16} height={16} fill="#DA2E2E" />
              출입문 열기에 실패했습니다.
            </DoorMessage>
        );
        setDoorError(true);
      }

    } catch (error) {
      setDoorMessage(
        <DoorMessage type="error">
          <FailureIcon width={16} height={16} fill="#DA2E2E" />
          출입문 열기에 실패했습니다.
        </DoorMessage>
      );
      console.error(error);
      setDoorError(true);
    } finally {
      setLoading(false);
    }
  };

  const getCenterInfo = async () => {
    setLoading(true);
    try {
      await api
        .get(
          `partners/${seqPartner}/${seqPartnerBranch ? seqPartnerBranch : 0}`
        )
        .then(({ data }) => {
          setInfo(data);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    getCenterInfo();
    getKioskList();
  }, []);

  return (
    <MainLayout
      withBottomTab={false}
      withHeader={true}
      backgroundColor="white"
      headerProps={{ withBackButton: true, centerTitle: "센터 정보 설정" }}
    >
      {loading && <Loading />}
      <Wrapper>
        <CenterBox>
          <Text
            display="block"
            color="primary100"
            fontSize="14px"
            fontWeight="500"
            lineHeight="18px"
          >
            {partner} {partnerBranch}
          </Text>
        </CenterBox>

        <MenuSections
            page="setting"
            sections={
              kiosks.length > 0
                  ? [...menuSections, { label: "출입문 제어", action: "openDoor" }]
                  : menuSections
            }
            state={location.state}
            info={info}
            onDoorOpen={handleOpenDoor}
        />

        {doorMessage && <DoorMessage error={doorError}>{doorMessage}</DoorMessage>}
      </Wrapper>
    </MainLayout>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: auto;
  padding: 0 20px;
`;

const CenterBox = styled.div`
  background: #eef5ff;
  border-radius: 6px;
  margin: 12px 0;
  padding: 12px 0;
  text-align: center;
`;

const DoorButton = styled.button`
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  color: #0066ff;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: #f5f9ff;
  }
`;

const DoorMessage = styled.div`
  display: flex;
  justify-content: flex-end; /* ✅ 컨텐츠 오른쪽 정렬 */
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: ${({ type }) =>
      type === "error" ? "#ff3636" : type === "success" ? "#004FEC" : "#333"};
`;

export default CenterSettings;
